import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-loading',
  templateUrl: './logo-loading.component.html',
  styleUrls: ['./logo-loading.component.scss']
})
export class LogoLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
